import * as n from "react";
import { p as i } from "./index-efd35e77.js";
import { l as $, v as G } from "./index-64063129.js";
var J = function(e, r) {
  var a = n.useRef(0), t = n.useRef(!1), u = n.useRef(), l = function(s) {
    var P = s.duration, d, v, c = a.current && 1 - a.current;
    s.onStart && s.onStart();
    var b = function(o) {
      d || (d = o), v = o - d + 1;
      var g = v / P + c;
      g <= 1 ? (s.onUpdate && s.onUpdate(g), u.current = window.requestAnimationFrame(b), a.current = g) : (s.onEnd && s.onEnd(1), a.current = 0);
    };
    u.current = window.requestAnimationFrame(b);
  };
  n.useEffect(function() {
    return l(e), function() {
      u.current && window.cancelAnimationFrame(u.current);
    };
  }, r), n.useEffect(function() {
    t.current = !0;
  }, []);
}, O = function() {
  for (var e = [], r = 0; r < arguments.length; r++)
    e[r] = arguments[r];
  var a = {}, t = function(l) {
    return typeof l == "object" ? Object.keys(l).forEach(function(s) {
      a[s] = l[s];
    }) : a[l] = !0;
  }, u = function(l) {
    return l.filter(function(s) {
      return s !== !0 && !!s;
    }).map(function(s) {
      return Array.isArray(s) ? u(s) : t(s);
    });
  };
  return u(e), Object.keys(a).map(function(l) {
    return a[l] && l || null;
  }).filter(function(l) {
    return l !== null;
  }).join(" ");
}, Q = -1, Y = 0, Z = function(e, r, a) {
  var t = typeof e == "string" ? parseInt(e, void 0) : e;
  if (t !== NaN)
    return t !== void 0 ? t : r ? a ? void 0 : Q : Y;
};
function ee(e) {
  if (typeof $ < "u")
    G(e);
  else {
    var r = "License activation failed for ".concat(e.name, `
`);
    r += `The @progress/kendo-licensing script is not loaded.
`, r += "See ".concat(e.licensingDocsUrl, ` for more information.
`), console.warn(r);
  }
}
function re(e, r, a) {
  var t = n.useState(r), u = t[0], l = t[1];
  return n.useEffect(function() {
    if (!u && window && e.current) {
      var s = window.getComputedStyle(e.current).direction;
      s && l(s);
    }
  }, a), u;
}
var ae = 3, ne = 400, te = 0, se = function(e) {
  var r = e.toString().split(".");
  return r.length === 1 ? "".concat(r[0]) : "".concat(r[0], ".").concat(r[1].substr(0, ae));
}, S = function(e, r, a) {
  var t = Math.abs((r - e) / 100);
  return Math.abs((a - e) / t);
}, A = function(e, r, a, t) {
  var u = Math.max(a, 0.01), l = 100 / u * 100;
  e.current && r.current && (e.current.style.width = t ? "100%" : "".concat(u, "%"), r.current.style.width = t ? "100%" : "".concat(l, "%"), e.current.style.height = t ? "".concat(u, "%") : "100%", r.current.style.height = t ? "".concat(l, "%") : "100%");
}, ue = {
  name: "@progress/kendo-react-progressbars",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1695801083,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning"
}, le = function(e) {
  var r = n.useRef();
  return n.useEffect(function() {
    r.current = e;
  }), r.current;
}, w = globalThis && globalThis.__assign || function() {
  return w = Object.assign || function(e) {
    for (var r, a = 1, t = arguments.length; a < t; a++) {
      r = arguments[a];
      for (var u in r)
        Object.prototype.hasOwnProperty.call(r, u) && (e[u] = r[u]);
    }
    return e;
  }, w.apply(this, arguments);
}, I = n.forwardRef(function(e, r) {
  ee(ue);
  var a = e.animation, t = e.disabled, u = e.reverse, l = u === void 0 ? h.reverse : u, s = e.orientation, P = e.labelVisible, d = e.labelPlacement, v = e.max, c = v === void 0 ? h.max : v, b = e.min, o = b === void 0 ? h.min : b, g = e.tabIndex, R = e.className, U = e.style, j = e.emptyStyle, T = e.emptyClassName, B = e.progressStyle, C = e.progressClassName, p = n.useRef(null), y = n.useRef(null), E = n.useRef(null), F = n.useCallback(function() {
    p.current && p.current.focus();
  }, []);
  n.useImperativeHandle(r, function() {
    return {
      element: p.current,
      progressStatusElement: y.current,
      progressStatusWrapElement: E.current,
      focus: F
    };
  });
  var f = e.value || h.value, N = le(f), D = e.value === null, K = re(p, e.dir), m = s === "vertical", M = se(f), V = {
    value: f
  }, _ = P ? e.label ? n.createElement(
    "span",
    { className: "k-progress-status" },
    n.createElement(e.label, w({}, V))
  ) : n.createElement("span", { className: "k-progress-status" }, M) : void 0, q = {
    className: O("k-progressbar", {
      "k-progressbar-horizontal": !m,
      "k-progressbar-vertical": m,
      "k-progressbar-reverse": l,
      "k-progressbar-indeterminate": D,
      "k-disabled": t
    }, R),
    ref: p,
    dir: K,
    tabIndex: Z(g, t),
    role: "progressbar",
    "aria-label": e.ariaLabel,
    "aria-valuemin": o,
    "aria-valuemax": c,
    "aria-valuenow": D ? void 0 : f,
    "aria-disabled": t,
    style: U
  }, x = O("k-progress-status-wrap", {
    "k-progress-start": d === "start",
    "k-progress-center": d === "center",
    "k-progress-end": d === "end" || d === void 0
  }), L = typeof a != "boolean" && a !== void 0 ? a.duration : a ? ne : te, X = n.useCallback(function() {
    var k = S(o, c, N);
    A(y, E, k, m);
  }, [m, c, o, N]), z = n.useCallback(function(k) {
    var W = S(o, c, N + (f - N) * k);
    A(y, E, W, m);
  }, [o, c, N, f, m]), H = n.useCallback(function() {
    var k = S(o, c, f);
    A(y, E, k, m);
  }, [m, c, o, f]);
  return J({
    duration: L,
    onStart: X,
    onUpdate: z,
    onEnd: H
  }, [f, L]), n.createElement(
    "div",
    w({}, q),
    n.createElement("span", { className: x + (T ? " " + T : ""), style: j }, _),
    n.createElement(
      "div",
      { className: "k-progressbar-value k-selected", style: B, ref: y },
      n.createElement("span", { className: x + (C ? " " + C : ""), ref: E }, _)
    )
  );
});
I.propTypes = {
  animation: i.any,
  ariaLabel: i.string,
  disabled: i.bool,
  reverse: i.bool,
  label: i.any,
  labelVisible: i.bool,
  labelPlacement: i.oneOf(["start", "center", "end"]),
  max: i.number,
  min: i.number,
  value: i.number,
  tabIndex: i.number,
  emptyStyle: i.object,
  emptyClassName: i.string,
  progressStyle: i.object,
  progressClassName: i.string
};
var h = {
  animation: !1,
  min: 0,
  max: 100,
  value: 0,
  disabled: !1,
  reverse: !1,
  labelVisible: !0
};
I.defaultProps = h;
I.displayName = "KendoProgressBar";
export {
  I as P
};
